import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/** Small yes/no gate for actions that are easy to fire and awkward to undo. */
export default function ConfirmDialog({
  open, onOpenChange, title, body, confirmLabel = "Confirm", onConfirm, testid,
  destructive = false,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={testid}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {body && <DialogDescription className="text-xs leading-relaxed">{body}</DialogDescription>}
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}
                  data-testid={`${testid}-cancel`}>
            Cancel
          </Button>
          <Button size="sm" variant={destructive ? "destructive" : "default"}
                  onClick={onConfirm} data-testid={`${testid}-confirm`}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
